import { BE_BASE_URL } from 'constants/app'
import { objectToQueryParams } from 'utils/RequestHelper'

export const exportUnderOverDepreciationURL = (payload: any) => {
  const params = objectToQueryParams(payload)
  return `${BE_BASE_URL}/v1/export/under_over_depreciation?${params}`
}
